<template>
<kt-panel>
    <div class="accordion accordion-toggle-arrow" id="userFilter">
        <div class="card" style="overflow:inherit">
            <div class="card-header bg-transparent" id="headingOne">
                <div class="card-title collapsed" data-toggle="collapse"
                    data-target="#filterForm"
                    aria-controls="filterForm">
                    {{ $t('label.search') }}
                </div>
            </div>
            <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                <div class="card-body">
                    <form @submit.prevent="action($event, query)" :id="'user-filter-form'+ form_id">
                        <kt-form-section>
                            <kt-form-row>
                                <!-- Row 1: Contact & Identity -->
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="phone">
                                            {{ $t('label.phone') }}
                                        </kt-form-label>
                                        <kt-form-control ref="phone" dir="ltr" name="phone" id="phone" v-model="query.phone" />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="telephone">
                                            {{ $t('label.telephone') }}
                                        </kt-form-label>
                                        <kt-form-control ref="telephone" dir="ltr" name="telephone" id="telephone" v-model="query.telephone" />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="full_name">
                                            {{ $t('label.full_name') }}
                                        </kt-form-label>
                                        <kt-form-control ref="full_name" name="full_name" id="full_name" v-model="query.full_name" />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="email">
                                            {{ $t('label.email') }}
                                        </kt-form-label>
                                        <kt-form-control ref="email" dir="ltr" name="email" id="email" v-model="query.email" />
                                    </kt-form-group>
                                </kt-col>

                                <!-- Row 2: Legal & Access -->
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="national_code">
                                            {{ $t('label.national_code') }}
                                        </kt-form-label>
                                        <kt-form-control ref="national_code" name="national_code" id="national_code" v-model="query.national_code" />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="national_legal_code">
                                            {{ $t('label.national_legal_code') }}
                                        </kt-form-label>
                                        <kt-form-control ref="national_legal_code" name="national_legal_code" id="national_legal_code" v-model="query.national_legal_code" />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="access_type">
                                            {{ $t('label.access_type') }}
                                        </kt-form-label>
                                        <kt-form-select ref="access_type" name="access_type" id="access_type" v-model="query.access_type">
                                            <option :value="userAccessType.ALL" v-text="userAccessTypeStr.get(userAccessType.ALL)"></option>
                                            <option :value="userAccessType.ADMIN" v-text="userAccessTypeStr.get(userAccessType.ADMIN)"></option>
                                            <option :value="userAccessType.WALLET_ACCESS" v-text="userAccessTypeStr.get(userAccessType.WALLET_ACCESS)"></option>
                                        </kt-form-select>
                                    </kt-form-group>
                                </kt-col>

                                <!-- Row 3: Statuses & Verification -->
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group ref="statusSelectGroup">
                                        <kt-form-label for="status">
                                            {{ $t('label.status') }}
                                        </kt-form-label>
                                        <kt-form-select size="3" id="status" class="form-control" name="status" v-model="query.status">
                                            <option
                                                v-bind:key="index"
                                                v-for="(status, index) in statuses"
                                                v-bind:value="status.value"
                                                :selected="query.status === status.value"
                                            >
                                                {{ status.name }}
                                            </option>
                                        </kt-form-select>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="gateway_status">
                                            {{ $t('label.gateway_status') }}
                                        </kt-form-label>
                                        <kt-form-select size="3" id="gateway_status" class="form-control" name="gateway_status" v-model="query.gateway_status">
                                            <option
                                                v-bind:key="index"
                                                v-for="(gateway_status, index) in gateway_statuses"
                                                v-bind:value="gateway_status.value"
                                                :selected="query.gateway_status === gateway_status.value"
                                            >
                                                {{ gateway_status.name }}
                                            </option>
                                        </kt-form-select>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="user_level">
                                            {{ $t('label.user_level') }}
                                        </kt-form-label>
                                        <kt-form-select size="3" id="user_level" class="form-control" name="user_level" v-model="query.user_level">
                                            <option>
                                                {{ $t('selectpicker.nothing_selected') }}
                                            </option>
                                            <option value="1">
                                                {{ $t('customers_club.l1') }}
                                            </option>
                                            <option value="2">
                                                {{ $t('customers_club.l2') }}
                                            </option>
                                            <option value="3">
                                                {{ $t('customers_club.l3') }}
                                            </option>
                                        </kt-form-select>
                                    </kt-form-group>
                                </kt-col>

                                <!-- Row 4: Registration Dates -->
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <div class="d-flex justify-content-between align-items-center mb-1">
                                            <kt-form-label for="from_date" class="mb-0">
                                                {{ $t('reports.tax.from_date') }} ({{ $t('label.register_date') }})
                                            </kt-form-label>
                                            <button
                                                id="reset_from_date"
                                                @click="clearFromDate"
                                                type="button"
                                                class="btn btn-sm btn-label-danger trash-btn p-1"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                        </div>
                                        <datePicker
                                            format="YYYY-MM-DD HH:mm:ss"
                                            display-format="dddd jDD jMMMM jYYYY"
                                            input-class="form-control"
                                            id="from_date"
                                            name="from_date"
                                            v-model="query.from_date"
                                            type="date"
                                        />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <div class="d-flex justify-content-between align-items-center mb-1">
                                            <kt-form-label for="to_date" class="mb-0">
                                                {{ $t('reports.tax.to_date') }} ({{ $t('label.register_date') }})
                                            </kt-form-label>
                                            <button
                                                id="reset_to_date"
                                                @click="clearToDate"
                                                type="button"
                                                class="btn btn-sm btn-label-danger trash-btn p-1"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                        </div>
                                        <datePicker
                                            format="YYYY-MM-DD HH:mm:ss"
                                            display-format="dddd jDD jMMMM jYYYY"
                                            input-class="form-control"
                                            id="to_date"
                                            name="to_date"
                                            v-model="query.to_date"
                                            type="date"
                                        />
                                    </kt-form-group>
                                </kt-col>

                                <!-- Row 5: User Access Permissions -->
                                <kt-col v-if="$can('read-sensitive-info', 'user')" xs="12" sm="6" md="4">
                                    <kt-form-group ref="statusSelectGroup">
                                        <kt-form-label for="user_access">
                                            {{ $t('label.user_access') }}
                                        </kt-form-label>
                                        <select
                                            size="5"
                                            multiple
                                            id="user_access"
                                            name="user_access"
                                            v-model="query.user_access"
                                            class="form-control kt-selectpicker"
                                        >
                                            <option v-for="permission in permissions" :key="permission.value" :value="permission.value">
                                                {{ permission.name }}
                                            </option>
                                        </select>
                                    </kt-form-group>
                                </kt-col>
                            </kt-form-row>
                        </kt-form-section>
                        <kt-form-section>
                            <kt-row>
                                <kt-col xs="12" sm="6" md="6">
                                    <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                                </kt-col>
                            </kt-row>
                        </kt-form-section>
                    </form>
                </div>
            </div>
        </div>
    </div>
</kt-panel>
</template>

<script>
import $ from 'jquery'
import { userStatusStr, userStatus } from '@/constants/userStatus'
import { gatewayStatusStr, gatewayStatus } from '@/constants/gatewayStatus'
import { userAccessType, userAccessTypeStr } from '@/constants/UserAccessType'
import { RolesArray } from '@/constants/RoleAndPermissions'
import {i18n} from "@/plugins/i18n";

export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true,
        },
          form_id: {
            required: true,
            default: '',
          },
    },
    computed: {
        permissions() {
            return RolesArray.map(role => {
                return role.permissions.map(permission => {
                    return {
                        'name': role.name + ' - ' + permission.name,
                        'value': permission.key,
                    }
                })
            }).flat()
        }
    },
    data() {
        return {
            userAccessType: userAccessType,
            userAccessTypeStr: userAccessTypeStr,
            statuses: [
                {
                    name: null,
                    value: null
                },
                {
                    name: userStatusStr.ACTIVE,
                    value: userStatus.ACTIVE
                },
                {
                    name: userStatusStr.REMOVED,
                    value: userStatus.REMOVED
                },
                {
                    name: userStatusStr.PENDING,
                    value: userStatus.PENDING
                },
                {
                    name: userStatusStr.IS_AUTHENTICATED,
                    value: userStatus.IS_AUTHENTICATED
                },
                {
                    name: userStatusStr.IS_AUTHENTICATED_PENDING,
                    value: userStatus.IS_AUTHENTICATED_PENDING
                },
                {
                    name: userStatusStr.AUTHORIZATION_DOCUMENTS_REJECTED,
                    value: userStatus.AUTHORIZATION_DOCUMENTS_REJECTED
                },
                {
                    name: userStatusStr.ENAMAD_AUTHENTICATED,
                    value: userStatus.ENAMAD_AUTHENTICATED
                },
                {
                  name: userStatusStr.USER_INQUIRY_REJECTED,
                  value: userStatus.USER_INQUIRY_REJECTED
                },
                {
                  name: userStatusStr.DEACTIVATED,
                  value: userStatus.DEACTIVATED
                },
                {
                    name: userStatusStr.TEMPORARY_BLOCK,
                    value: userStatus.TEMPORARY_BLOCK
                },
            ],
            gateway_statuses: [
                {
                    name: '',
                    value: ''
                },
                {
                    name: gatewayStatusStr.ACTIVE,
                    value: gatewayStatus.ACTIVE
                },
                {
                    name: gatewayStatusStr.PENDING,
                    value: gatewayStatus.PENDING
                },
                {
                    name: gatewayStatusStr.SEND_TO_SHAPARAK,
                    value: gatewayStatus.SEND_TO_SHAPARAK
                },
                {
                    name: gatewayStatusStr.REJECTED,
                    value: gatewayStatus.REJECTED
                },
                {
                    name: gatewayStatusStr.HAS,
                    value: gatewayStatus.HAS
                },
                {
                    name: gatewayStatusStr.DOES_NOT_HAVE,
                    value: gatewayStatus.DOES_NOT_HAVE
                },
                {
                    name: gatewayStatusStr.DIRECT_TO_PSP,
                    value: gatewayStatus.DIRECT_TO_PSP
                },
            ],
            query: {
                user_access: []
            },
        }
    },
    mounted() {
        setTimeout( () => {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        }, 1500)
    },

    methods: {
        clearFromDate() {
            if(this.query.from_date) {
                this.query.from_date = null
            }
        },
        clearToDate() {
            if(this.query.to_date) {
                this.query.to_date = null
            }
        },
    }

}
</script>

<style>

</style>